import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  form: {
    display: 'flex',
    gap: 8 ,

    '& > button': {
      height: 40,
      padding: '0 16px',
      marginTop: 8,
      marginBottom: 4,
      position: 'absolute',
      right: 24,
    },

    '& .MuiTextField-root label': {
      width: 'calc(100% - 90px)',
      overflow: 'hidden', 
      textOverflow: 'ellipsis', 
      whiteSpace: 'nowrap', 
      maxWidth: 180
    }

  },

  info: {
    '& > div': {
      marginTop: 8,
      marginRight: 8
    }
  }

}))